import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=232021c4&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"
import style0 from "./Asset.vue?vue&type=style&index=0&id=232021c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232021c4",
  null
  
)

export default component.exports